export enum FileSortKeys {
  CreatedAt = "CREATED_AT",
  Filename = "FILENAME",
  Id = "ID",
  OriginalUploadSize = "ORIGINAL_UPLOAD_SIZE",
  Relevance = "RELEVANCE",
}